import api from "@/lib/api";

// Authenticated blob download (cookies are sent via api's withCredentials).
export async function downloadFile(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
}

export const ACCEPT_UPLOAD = ".pdf,.docx,.xlsx,.doc,.xls,.png,.jpg,.jpeg";
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
